<template>
  <div
    v-if="location?.lat && location.lon"
    ref="el"
    class="address-map"
    itemprop="geo"
    itemscope
    itemtype="https://schema.org/GeoCoordinates"
  >
    <TeaserMapPlaceholder v-if="!shouldRender" />
    <ClientOnly>
      <LazyMapsSingle
        v-if="shouldRender && latlon"
        :location="latlon"
        :title="title"
      />
    </ClientOnly>
    <meta itemprop="latitude" :content="location.lat.toString()" />
    <meta itemprop="longitude" :content="location.lon.toString()" />
  </div>
</template>

<script lang="ts" setup>
interface LatLon {
  lat: number
  lon: number
}

const props = withDefaults(
  defineProps<{
    location?: LatLon
    title?: string
  }>(),
  {
    title: '',
    location: undefined,
  },
)

const el = ref<HTMLElement>()
const shouldRender = useRenderWhenVisible(el)

const latlon = computed<[number, number] | null>(() => {
  if (props.location?.lat && props.location.lon) {
    return [props.location.lat, props.location.lon]
  }
  return null
})
</script>

<style lang="postcss">
.address-map {
  .map-poi {
    @apply relative z-10 h-[15rem];
  }
}
</style>
